var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66667 1.83333C7.03467 1.83333 7.33333 2.13199 7.33333 2.49999V5.16666C7.33333 5.53466 7.03467 5.83333 6.66667 5.83333H5.33333V7.16666H8.66667V6.5C8.66667 6.132 8.96533 5.83333 9.33333 5.83333H13.3333C13.7013 5.83333 14 6.132 14 6.5V9.16666C14 9.53466 13.7013 9.83333 13.3333 9.83333H9.33333C8.96533 9.83333 8.66667 9.53466 8.66667 9.16666V8.5H5.33333V12.5H8.66667V11.8333C8.66667 11.4653 8.96533 11.1667 9.33333 11.1667H13.3333C13.7013 11.1667 14 11.4653 14 11.8333V14.5C14 14.868 13.7013 15.1667 13.3333 15.1667H9.33333C8.96533 15.1667 8.66667 14.868 8.66667 14.5V13.8333H4.66667C4.29867 13.8333 4 13.5347 4 13.1667V5.83333H2.66667C2.29867 5.83333 2 5.53466 2 5.16666V2.49999C2 2.13199 2.29867 1.83333 2.66667 1.83333H6.66667ZM12.6667 12.5H10V13.8333H12.6667V12.5ZM12.6667 7.16666H10V8.5H12.6667V7.16666ZM6 3.16666H3.33333V4.49999H6V3.16666Z",
    fill: "#4C5664"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryGroup);
export default __webpack_public_path__ + "static/media/query-group.36b29bc5aaeedaccdf48e85b1ea48d51.svg";
export { ForwardRef as ReactComponent };